import { useEffect } from 'react';
import EventManager from './event-manager';
import { CommonEventType, EventName } from './types';

export type EventConfig = {
  eventName?: EventName | 'message';
  type: CommonEventType | '*';
  handler: (event: Event) => void;
};

export function useEventManagerRegister(events: EventConfig[]) {
  useEffect(() => {
    // Register all handlers
    const offs = events.map(({ eventName = 'message', type, handler }) =>
      EventManager.registerListener(eventName, type, handler),
    );

    // Cleanup all handlers on unmount
    return () => {
      offs.forEach((off) => off());
    };
  }, [events]);
}
